<template>
  <div>
    
  </div>
</template>

<script>

import {TokenService} from "./../storage/service"

export default {
  name: 'Dashboard',
  data: function () {
    return {
      
    };
  },
  mounted() {
    this.login();

  },

  created(){

  },

  methods: {
    login(){
      let token = TokenService.getToken()
      this.$http.post(this.backendURL + 'api/v1.0/checkSession/', {headers: {'Authorization': 'Token ' + token}})
      .then(() => {
        console.log("Token Correcto")
      })
      .catch(err => {
        // catch error});
        if(err.request.statusText == 'Unauthorized'){
          alert("Su sesion ha expirado...")
          this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
        }
        else {
          console.log(err.data)
        }
      })
    },
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 0;
}
</style>
